import FragmentMetadata from './fragment-metadata';

import { Node } from '.';

/**
 * Store that keeps all the fragment metadata structure in runtime.
 */
class MetadataStore {

  private metadatas = new Map<string, FragmentMetadata>();
  
  /**
   * Register a new fragment into the store.
   * 
   * @param name the name of the fragment.
   * @param rootNode the root node.
   * 
   * @throws when already exists using the received name.
   */
  register(name: string, rootNode?: Node): void {

    if (this.metadatas.has(name)) {
      throw new Error(`There already exists a fragment named '${name}'.`);
    }

    const fragmentMetadata = new FragmentMetadata(name, rootNode);
    fragmentMetadata.validate();

    this.metadatas.set(name, fragmentMetadata);
  }

  /**
   * Unregister the metadata from the store.
   * 
   * @param name the fragemnt name.
   */
  unregister(name: string): void {
    this.metadatas.delete(name);
  }

  /**
   * Retrieves the FragmentMetadata instance, if exists.
   * 
   * @param name the fragment name.
   */
  get(name: string): FragmentMetadata | null {
    return this.metadatas.get(name) || null;
  }

}

export default MetadataStore;
